import type { DropdownMenuOption } from '@/components/core-components/StanDropdown/StanDropdown.types';
import { useMyStore } from '@/queries/useStoreData';
import { useMemo } from 'react';

export interface AffiliateProductOption {
    name: string;
    page_id: number;
    image?: string;
}

/**
 * Hook to get available affiliate products from stores
 * Returns products that have resell rights enabled with a percentage > 0
 */
export function useAffiliateProducts() {
    const { data: stores, isLoading } = useMyStore();

    const availableProducts = useMemo((): AffiliateProductOption[] => {
        if (!stores || stores.length === 0) return [];

        const products: AffiliateProductOption[] = [];

        stores.forEach(store => {
            store.pages?.forEach(_page => {
                // const pageData = page.data;
                // const resellRights = pageData?.resell_rights;
                // if (resellRights?.enabled && resellRights?.percentage > 0) {
                //     products.push({
                //         name: pageData?.product?.title || 'Unnamed Product',
                //         page_id: page.page_id,
                //         image: pageData?.location === 'store' ? pageData?.button?.image : pageData?.product?.image,
                //     });
                // }
            });
        });

        return products;
    }, [stores]);

    const dropdownOptions = useMemo((): DropdownMenuOption[] => {
        return availableProducts.map(product => ({
            label: product.name,
            value: String(product.page_id),
            icon: product.image,
        }));
    }, [availableProducts]);

    const findProductByPageId = (pageId: string): AffiliateProductOption | undefined => {
        return availableProducts.find(p => String(p.page_id) === pageId);
    };

    return {
        availableProducts,
        dropdownOptions,
        findProductByPageId,
        isLoading,
    };
}
